import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import { Users } from "../api/account/Users";
import { _prepareUser, accountIsAuthorized } from "./utils";

type Auth = {
  signIn: Function;
  signOut: Function;
  isAllowedToAccessSupport: Function;
  isLogged: boolean;
  user: any;
  user35: any;
  isLoading: boolean;
  initOnAuth: Function;
};

const authContext = createContext<Auth>(undefined!);

export const ProvideAuth = ({ children }) => {
  const auth: any = useProvideAuth();

  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
};

export const useAuth = () => {
  return useContext(authContext);
};

const useProvideAuth = (): Auth => {
  const [user, setUser] = useState<any>(null);
  //! keep the user 35 information
  const [user35, setUser35] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLogged, setIsLogged] = useState(false);

  const userAPI = useMemo(() => new Users(), []);

  const initOnAuth = useCallback(
    async (response) => {
      let user35data = await userAPI.impersonate(35);
      setUser(response);
      setIsLogged(true);
      setUser35(user35data);
      setIsLoading(false);
    },
    [userAPI],
  );

  const signOut = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await userAPI.logout();
      if (response.status === "OK") {
        setUser(null);
        setIsLogged(false);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      alert("Something went wrong on logout...");
    }
  }, [userAPI]);
  const signIn = useCallback(
    (username, password) => {
      setIsLoading(true);
      try {
        return userAPI.login({ email: username, password: password }).then(
          async (response) => {
            if (accountIsAuthorized(_prepareUser(response)) === false) {
              setIsLoading(false);
              signOut();
              return { status: "KO", message: "Forbidden 403" };
            }
            let user35data = await userAPI.impersonate(35);
            setUser35(user35data);
            setUser(response);
            setIsLogged(true);
            setIsLoading(false);
            return { status: "OK", message: "" };
          },
          (error) => {
            if (error.response.status === 401) {
              setIsLoading(false);
              return { status: "KO", message: "Unauthorized(401)" };
            }
          },
        );
      } catch (error) {
        setIsLoading(false);
      }
    },
    [signOut, userAPI],
  );

  const isAllowedToAccessSupport = useCallback(
    async (response) => {
      if (accountIsAuthorized(_prepareUser(response)) === false) {
        setIsLoading(false);
        signOut();
        return false;
      }
      return true;
    },
    [signOut],
  );

  return {
    isLogged,
    user,
    user35,
    signIn,
    signOut,
    isLoading,
    initOnAuth,
    isAllowedToAccessSupport,
  };
};
